"use client";
import React, { useEffect, useState } from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { Leadconversation } from "./Leadconversation";
import { Leadtranscription } from "./Leadtranscription";
import * as _utils from "./utils";
import _styles from "./Leadconvomain.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-969":{"id":"e-969","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-59","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-970"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8f56a87f-1e4c-608f-7a46-b44695f74007","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8f56a87f-1e4c-608f-7a46-b44695f74007","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223210325},"e-971":{"id":"e-971","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-60","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-972"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"82b60712-1db2-82f6-9779-f7d827476abe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"82b60712-1db2-82f6-9779-f7d827476abe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721223253184}},"actionLists":{"a-59":{"id":"a-59","title":"return to history","actionItemGroups":[{"actionItems":[{"id":"a-59-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".leadconversation-main","selectorGuids":["90bbc54c-84e7-6f65-1011-735715452387"]},"value":"none"}},{"id":"a-59-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721223218070},"a-60":{"id":"a-60","title":"leadconversation [go]","actionItemGroups":[{"actionItems":[{"id":"a-60-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".leadconversation-main","selectorGuids":["90bbc54c-84e7-6f65-1011-735715452387"]},"value":"flex"}},{"id":"a-60-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".history","selectorGuids":["69e20447-9e8a-4c7a-b9bf-d8787134d1b8"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1721223255293}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function Leadconvomain({ as: _Component = _Builtin.Block, interDataLeadsExist = false, interDataLeads = [],
  interLeadsLoading = false, transLeadData=[], transLeadsLoading = false, handleClickInterLeads = () => { }, leadBaseInfo = { },
  loadMoreInter = () => { }, isLoadingMore = false
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  const [currentTab, setCurrentTab] = useState("Tab 1");
  const [fadeClass, setFadeClass] = useState("active");

  useEffect(() => {
    setFadeClass("inactive");
    const timeout = setTimeout(() => setFadeClass("active"), 100);

    return () => clearTimeout(timeout);
  }, [currentTab]);

  useEffect(() => {
    setCurrentTab("Tab 1");
  }, [interDataLeads]);

  const handleActiveTab = (tab) => {
    setCurrentTab(tab);
  }

  return (
    <_Component
      className={_utils.cx(_styles, "leadconversation-main")}
      tag="div"
      style={{ display: interDataLeadsExist ? "flex" : "none" }}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "conversationtop")}
        tag="div"
      >
        <_Builtin.Block className={_utils.cx(_styles, "smstop_left")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "iconbtn-return")}
            data-w-id="8f56a87f-1e4c-608f-7a46-b44695f74007"
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="images/66968578d5889c78730e319a_icon_return.svg"
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "avatar", "larger")}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "avatar_image")}
              width="auto"
              height="auto"
              loading="lazy"
              alt=""
              src={leadBaseInfo.avatar}
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "widget_headertextcontent")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "phoneheader_text")}
              tag="h3"
            >
              {leadBaseInfo.name}
            </_Builtin.Heading>
            <_Builtin.Block
              className={_utils.cx(_styles, "previewtext")}
              tag="div"
            >
              {leadBaseInfo.address}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "smstop_right")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "phonetop_iconbtn")}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              width="auto"
              height="auto"
              loading="lazy"
              alt=""
              src="images/66968578d5889c78730e31aa_icon_threedots.svg"
            />
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <div className={"convo-tabs"} >
        <div className={"convo-tabsmenu"}>
          <a className={`convo-tablink w-inline-block w-tab-link ${currentTab === "Tab 1" && "w--current"}`}
            onClick={() => setCurrentTab("Tab 1")}
          >
            <_Builtin.Block tag="div">{"Conversation"}</_Builtin.Block>
          </a>
          <a className={`convo-tablink w-inline-block w-tab-link ${currentTab === "Tab 2" && "w--current"}`}
            onClick={() => transLeadData.length !== 0 && setCurrentTab("Tab 2")}
            title={transLeadData.length === 0 ? "No Transcription Available" : ""}
          >
            <_Builtin.Block tag="div">{"Transcription"}</_Builtin.Block>
          </a>
        </div>
        <div className="convo-tabscontent" >
          <div className={`convo-tabpane ${currentTab === "Tab 1" ? fadeClass : ""}`} style={{ display:  currentTab === "Tab 1" ? "block" : "none"}}>
            <Leadconversation handleActiveTab={handleActiveTab} data={interDataLeads} interLeadsLoading={interLeadsLoading}
              handleClickInterLeads={handleClickInterLeads} isLoadingMore={isLoadingMore} isFetchingInteractions={false} loadMoreInter={loadMoreInter} 
            />
          </div>
          <div className={`convo-tabpane ${currentTab === "Tab 2" ? fadeClass : ""}`} style={{ display: currentTab === "Tab 2" ? "block" : "none"}}>
            <Leadtranscription data={transLeadData.transcript} transLeadsLoading={transLeadsLoading} />
          </div>
        </div>
      </div>
    </_Component>
  );
}
